import ACTION_TYPES from './actionTypes';

export const reducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.SET_INITIAL_DATA:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
